/**
 * Interactive terminal component for executing commands in a sandbox.
 * Full-featured terminal emulator using xterm.js with WebSocket exec stream.
 * Supports multiple tabs and split-pane views.
 *
 * @module components/terminal/SandboxTerminal
 */

import { TerminalContainer } from './TerminalContainer';

interface SandboxTerminalProps {
  sandboxId: string;
  /** Optional container name for pod sandboxes */
  containerName?: string;
  /** Optional sandbox group ID — when set, uses group-scoped URL paths */
  sandboxGroupId?: string;
  onClose?: () => void;
  onConnectionError?: () => void;
}

/**
 * Interactive terminal for executing commands in a sandbox via WebSocket.
 * This component wraps TerminalContainer and provides the public API.
 *
 * Features:
 * - Multiple terminal tabs (up to 10)
 * - Split-pane view for side-by-side terminals
 * - Fullscreen mode
 * - Auto-connecting WebSocket shells
 * - Connection status indicators
 */
export function SandboxTerminal({
  sandboxId,
  containerName,
  sandboxGroupId,
  onClose,
  onConnectionError,
}: SandboxTerminalProps) {
  return (
    <TerminalContainer
      sandboxId={sandboxId}
      containerName={containerName}
      sandboxGroupId={sandboxGroupId}
      onClose={onClose}
      onConnectionError={onConnectionError}
    />
  );
}
